import { Injectable } from '@angular/core';
import { LogisticaRepository } from './logistica.repository';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AutorizacionOperaciones_Request, ReporteAuthVentaRequest } from '../autorizacion-cambio-venta/domain/reporte-autorizacion-request';
import { ReporteAuthVentaResponse, TnsReporteAuthVentaResponse } from '../autorizacion-cambio-venta/domain/reporte-autorizacion-response';
import { ActualizarEstatusRequest, AnularDocumentoRequest, DesvincularSAPRequest, DocumentosProveedorRelacionadosRequest, ObtenerDocumentosProveedorRequest, ObtenerFacturasPreRegistradasRequest, ObtenerOperacionRequest, SincronizarDocumentoRequest } from '../facturacion-compras/domain/facturacion-compras-request.interface';
import { ApiResponse, ApiResponseObject, DocumentosProveedorRelacionadosResponse, FacturaPreRegistradaDTO, ObtenerDocumentosProveedorResponse, ResultOperacionLogistica, SincronizarDocumentoResponse } from '../facturacion-compras/domain/facturacion-compras-response.interface';

@Injectable({
  providedIn: 'root'
})
export class LogisticaService extends LogisticaRepository {

  constructor(
    private readonly http: HttpClient
  ) {
    super()
  }

  override getFilterByOrdenCompra(request: any): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/logistica/getFilterByOrdenCompra`, request)
  }
  override ReporteAutorizacion(request: ReporteAuthVentaRequest): Observable<ReporteAuthVentaResponse> {
    return this.http.post<ReporteAuthVentaResponse>(`${environment.PATH_API}/comercial/ReporteAuthVenta`, request);
  }
  override transaccionAutorizacionOperacionesSli(request: AutorizacionOperaciones_Request): Observable<TnsReporteAuthVentaResponse> {
    return this.http.post<TnsReporteAuthVentaResponse>(`${environment.PATH_API}/comercial/tnsAutorizarOperacionesPorAutorizar`, request);
  }
  override ObtenerDocumentosProveedor(request: ObtenerDocumentosProveedorRequest): Observable<ApiResponse<ObtenerDocumentosProveedorResponse>> {
    return this.http.post<ApiResponse<ObtenerDocumentosProveedorResponse>>(`${environment.PATH_API}/logistic/obtenerDocumentosProveedor`, request);
  }
  override ObtenerOperacionLogistica(request: ObtenerOperacionRequest): Observable<ApiResponseObject<ResultOperacionLogistica>> {
    return this.http.post<ApiResponseObject<ResultOperacionLogistica>>(`${environment.PATH_API}/logistic/ObtenerOperacionLogistica`, request);
  }
  override insertarDocumento(request: any): Observable<ApiResponseObject<any>> {
    return this.http.post<ApiResponseObject<any>>(`${environment.PATH_API}/logistic/insertarDocumento`, request);
  }
  override actualizarEstatus(request: ActualizarEstatusRequest): Observable<ApiResponseObject<any>> {
    return this.http.post<ApiResponseObject<any>>(`${environment.PATH_API}/logistic/ActualizarEstatus`, request);
  }
  override actualizarDocumento(request: any): Observable<ApiResponseObject<null>> {
    return this.http.post<ApiResponseObject<null>>(`${environment.PATH_API}/logistic/actualizarDocumento`, request);
  }
  override procesoSAPDocumento(request: any): Observable<ApiResponseObject<null>> {
    return this.http.post<ApiResponseObject<null>>(`${environment.PATH_API}/logistic/procesoSAPDocumento`, request);
  }
  override obtenerDocumentosProveedorRelacionados(request: DocumentosProveedorRelacionadosRequest): Observable<ApiResponseObject<DocumentosProveedorRelacionadosResponse>> {
    return this.http.post<ApiResponseObject<DocumentosProveedorRelacionadosResponse>>(`${environment.PATH_API}/logistic/obtenerDocumentosProveedorRelacionados`, request);
  }
  override ObtenerFacturasPreRegistradas(request: ObtenerFacturasPreRegistradasRequest): Observable<ApiResponse<FacturaPreRegistradaDTO>> {
    return this.http.post<ApiResponse<FacturaPreRegistradaDTO>>(`${environment.PATH_API}/logistic/obtenerFacturasPreRegistradas`, request);
  }
  override anularDocumento(request: AnularDocumentoRequest): Observable<ApiResponseObject<number>> {
    return this.http.post<ApiResponseObject<number>>(`${environment.PATH_API}/logistic/anularDocumento`, request);
  }
  override sincronizarDocumentoCompleto(request: SincronizarDocumentoRequest): Observable<SincronizarDocumentoResponse> {
    return this.http.post<SincronizarDocumentoResponse>(`${environment.PATH_API}/logistic/sincronizarDocumentoCompleto`, request);
  }
  override desvincularSAP(request: DesvincularSAPRequest): Observable<ApiResponseObject<any>> {
    return this.http.post<ApiResponseObject<any>>(`${environment.PATH_API}/logistic/DesvincularSAP`, request);
  }
}
